var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Component } from 'react';
import Transition from 'react-transition-group/Transition';
import { SubmissionError } from 'redux-form';
import { FORBIDDEN } from '../../../../define/response';
import { reDraw } from '../../../../helpers/common';
import { propBool, propFunc } from '../../../../helpers/custom-prop-types';
import { createValidateErrorData } from '../../../../helpers/validate';
import ConsultantSearchSlideLoginForm from './ConsultantSearchSlideLoginForm';
class ConsultantSearchSlideLogin extends Component {
    constructor() {
        super(...arguments);
        this.onSubmit = (values) => __awaiter(this, void 0, void 0, function* () {
            const { onSubmitLogin, updateProfile } = this.props;
            try {
                const { payload } = yield onSubmitLogin(values);
                updateProfile(payload);
            }
            catch (e) {
                const errorMessage = createValidateErrorData(e, {
                    [FORBIDDEN]: 'ログインID、またはパスワードが正しくありません。',
                });
                throw new SubmissionError(errorMessage);
            }
        });
    }
    render() {
        const { hasSlideRole, isShowLoginModal, onClickLoginClose } = this.props;
        return (_jsx(Transition, Object.assign({ in: isShowLoginModal && !hasSlideRole, mountOnEnter: true, onEnter: reDraw, timeout: 300, unmountOnExit: true }, { children: (state) => (_jsxs(_Fragment, { children: [_jsx("div", { className: `slide-login-form-bg ${state}`, onClick: onClickLoginClose, role: 'presentation' }), _jsx("div", Object.assign({ className: `slide-login-form-box ${state}` }, { children: _jsx("div", Object.assign({ className: 'slide-login-form' }, { children: _jsx(ConsultantSearchSlideLoginForm, { onSubmit: this.onSubmit }) })) }))] })) })));
    }
}
ConsultantSearchSlideLogin.propTypes = {
    hasSlideRole: propBool().isRequired,
    isShowLoginModal: propBool().isRequired,
    onClickLoginClose: propFunc(),
    onSubmitLogin: propFunc().isRequired,
    updateProfile: propFunc().isRequired,
};
ConsultantSearchSlideLogin.defaultProps = {
    onClickLoginClose: undefined,
};
export default ConsultantSearchSlideLogin;
